import Vue from 'vue'
import Vuex from 'vuex'

import system from './modules/system.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    system,
  }
})
